import {
    GET_ILINK_STATUS_REQUEST,
    GET_ILINK_STATUS_SUCCESS,
    GET_ILINK_STATUS_FAILURE
} from '../constants/';

const INIT_STATE = {
    isLoading: false,
    isInitialFetch: true,
    data: [],
    error: null,
}

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_ILINK_STATUS_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        case GET_ILINK_STATUS_SUCCESS:
            return {
                ...state,
                isLoading: false,
                data: action.payload.modems,
                isInitialFetch: false,
            };
        case GET_ILINK_STATUS_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload.error.stack,
            };
        default:
            return state;
    }
};